// extracted by mini-css-extract-plugin
module.exports = {"game_container":"Game_game_container__3RHGn","card_grid":"Game_card_grid__BR5Rz"};